import React from "react";
import PageLayout from "../components/PageLayout";
import PageHero from "../components/PageHero";
import Contact from "../components/Contact";

const ContactPage = () => (
    <PageLayout title="Contact · IndoBlitz" hideContactCta testId="contact-page">
        <PageHero
            eyebrow="Contact"
            title="Start a"
            accent="conversation."
            intro="Tell us which lane you're in. We respond within one business day with a real human and a real plan - not a templated email."
            testId="contact-hero"
        />
        <Contact />
    </PageLayout>
);

export default ContactPage;
